var _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoPlaceholder(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.565,
    height: 101.565,
    viewBox: "0 0 101.565 101.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61978",
    "data-name": "Path 61978",
    d: "M0,0H101.565V101.565H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(11.239 11.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104565",
    "data-name": "Group 104565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M39.543,0A39.543,39.543,0,1,0,79.087,39.543,39.543,39.543,0,0,0,39.543,0ZM56.2,40.8a2.825,2.825,0,0,1-1.268,1.268v.014l-22.6,11.3a2.825,2.825,0,0,1-4.087-2.542v-22.6a2.825,2.825,0,0,1,4.087-2.528l22.6,11.3A2.824,2.824,0,0,1,56.2,40.8Z",
    fill: "#03e67c"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaceholder);
export default __webpack_public_path__ + "static/media/video_placeholder.ae917519533123a24312212eaae9fcc8.svg";
export { ForwardRef as ReactComponent };